// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1xaVT","alertIcon":"ConfirmModal_alertIcon__3XOA6"};